<template>
  <div class="row text-center">
    <div class="col-12">
      <div class="row match-height">
        <div class="col-12 col-md-4 text-left">
          <div class="card card-congratulation-medal">
            <div class="card-body">              
              <h4 style="margin-top: 1px; color: #777; padding-bottom: 5px;"><strong>¡Utiliza nuestra App Movil 🎉!</strong></h4>
              <div class="card-text font-small-3" style="margin-bottom: 5px !important;">Disponible, <i><strong>solo para Android.</strong></i>
              </div>
              <a type="button" class="btn btn-primary"
                href="https://play.google.com/store/apps/details?id=io.framework7.facturaso&hl=es_419" target="_blank">Descargar Play Store</a>
              <img src="http://www.facturaso.com/extras/android.png" class="congratulation-medal" alt="Medal Pic" />
            </div>
          </div>
        </div>
        <!-- Statistics Card -->
         
        <div class="col-xl-8 col-md-6 col-12">
          <div class="card card-statistics">
            <div class="card-body statistics-body">
              <div class="row border-bottom pb-2 mb-3 no-gutters justify-content-left" style="margin-top: -10px !important;">
                  <label class="h5 mb-2">
                      Estadisticas Rapidas
                  </label>
              </div>
              <div class="row">
                <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0"
                  style="padding-left: 8px !important; padding-right: 8px !important;">
                  <div class="d-flex flex-row">
                    <div class="avatar bg-light-green me-2">
                      <div class="avatar-content">
                        <!-- {{-- <i data-feather="trending-up" class="avatar-icon"></i>                                     --}} -->
                        <!-- {{-- <i class="fa fa-search fa-lg"></i> --}} -->
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-send">
                            <line x1="22" y1="2" x2="11" y2="13"></line>
                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div class="my-auto">
                      <h4 class="fw-bolder mb-0" :style="{ textAlign: 'left' }"
                        style="margin-top: 0px; line-height: normal; font-weight: 800; text-align: left;">
                        {{ formatTotal(total_cpe) }}
                      </h4>
                      <p class="card-text font-small-3 mb-0 text-left">Emisiones</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0"
                  style="padding-left: 8px !important; padding-right: 8px !important;">
                  <div class="d-flex flex-row">
                    <div class="avatar bg-light-red me-2">
                      <div class="avatar-content">
                        <!-- {{-- <i data-feather="user" class="avatar-icon"></i> --}} -->
                        <!-- {{-- <i class="fa fa-search fa-lg"></i> --}} -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-file-text">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                      </div>
                    </div>
                    <div class="my-auto">
                      <h4 class="fw-bolder mb-0" :style="{ textAlign: 'left' }"
                        style="margin-top: 0px; line-height: normal; font-weight: 800; text-align: left;">
                        S/ {{ formatTotal(document_total_global) }}
                      </h4>
                      <p class="card-text font-small-3 mb-0 text-left">En CPE</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-sm-0"
                  style="padding-left: 8px !important; padding-right: 8px !important;">
                  <div class="d-flex flex-row">
                    <div class="avatar bg-light-purple me-2">
                      <div class="avatar-content">
                        <!-- {{-- <i data-feather="box" class="avatar-icon"></i> --}} -->
                        <!-- {{-- <i class="fa fa-search fa-lg"></i> --}} -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-file">
                          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                          <polyline points="13 2 13 9 20 9"></polyline>
                        </svg>
                      </div>
                    </div>
                    <div class="my-auto">
                      <h4 class="fw-bolder mb-0"
                        style="margin-top: 0px; line-height: normal; font-weight: 800; text-align: left;">
                        S/ {{ formatTotal(sale_note_total_global) }}
                      </h4>
                      <p class="card-text font-small-3 mb-0" style="text-align: left;">En NV</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-sm-6 col-12"
                  style="padding-left: 8px !important; padding-right: 8px !important;">
                  <div class="d-flex flex-row">
                    <div class="avatar bg-light-skyblue me-2">
                      <div class="avatar-content">
                        <!-- {{-- <i data-feather="dollar-sign" class="avatar-icon"></i> --}} -->
                        <!-- {{-- <i class="fa fa-search fa-lg"></i> --}} -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-package">
                          <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                          <path
                            d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                          </path>
                          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                          <line x1="12" y1="22.08" x2="12" y2="12"></line>
                        </svg>
                      </div>
                    </div>
                    <div class="my-auto">
                      <h4 class="fw-bolder mb-0" :style="{ textAlign: 'left' }"
                        style="margin-top: 0px; line-height: normal; font-weight: 800; text-align: left;">
                        S/ {{ formatTotal(total) }}
                      </h4>
                      <p class="card-text font-small-3 mb-0 text-left">Facturado</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/ Statistics Card -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["company", 'utilities'],
  data() {
    return {
      document_total_global: 0,
      total_cpe: 0,
      sale_note_total_global: 0,
      total: 0,
    };
  },
  mounted() {
    this.onFetchData();
  },
  computed: {
    isDueWarning() {
      if (this.company.certificate_due) {
        const dueDate = moment(this.company.certificate_due);

        const now = moment();
        const diffInDays = dueDate.diff(now, 'days')
        return diffInDays <= 15;
      }
      return false;
    },
  },
  methods: {
    onFetchData() {
      this.$http.get("/dashboard/global-data").then((response) => {
        const data = response.data;
        this.document_total_global = data.document_total_global;
        this.total_cpe = data.total_cpe;
        this.sale_note_total_global = data.sale_note_total_global;
        this.total =
          parseFloat(this.document_total_global) +
          parseFloat(this.sale_note_total_global);
      });
    },
    formatTotal(value) {
      if (value < 1000) return value;
      const units = ["K", "M", "B", "T"];
      let index = 0;
      while (value >= 1000 && index < units.length) {
        value /= 1000;
        index++;
      }
      return `${Math.round(value)}${units[index - 1]}`;
    }
  },
};
</script>
<style>
.card-green {
  background-color: green;
  color: white;
}

.is-due-warning {
  background-color: red;
}

.card-green .card-title {
  color: white;
}
</style>



// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/RowTop.vue